import React from 'react'
import { FormControlLabel, Radio } from '@material-ui/core'
import { Field } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import { isString } from 'lodash'
import { RadioGroup } from 'civic-champs-shared/formik/components/RadioGroup'

export interface RadioOption {
  value: string | boolean
  label: string
}

const useStyles = makeStyles({
  checkboxLabel: {
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  checkboxContainer: {
    marginLeft: 0,
  },
  checkbox: {},
  radio: {
    padding: '5px 9px',
  },
  checkboxChecked: {
    '&$checkbox, &$radio': {
      color: '#0F5DB5',
    },
  },
})

export const RadioGroupFormField = ({
  options,
  name,
  disabled,
  valueIsBoolean,
  unGap,
}: {
  options: RadioOption[]
  name: string
  disabled?: boolean
  valueIsBoolean?: boolean
  unGap?: boolean
}) => {
  const classes = useStyles()
  return (
    <Field component={RadioGroup} name={name} valueIsBoolean={valueIsBoolean} unGap={unGap}>
      {options.map(({ value, label }) => {
        const stringValue = isString(value) ? value : value.toString()
        return (
          <FormControlLabel
            classes={{ root: classes.checkboxContainer, label: classes.checkboxLabel }}
            key={stringValue}
            value={stringValue}
            control={
              <Radio
                size="small"
                classes={{ root: classes.radio, checked: classes.checkboxChecked }}
                disabled={disabled}
              />
            }
            label={label}
          />
        )
      })}
    </Field>
  )
}

export default RadioGroupFormField
